// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-react-datepicker__wrapper {
  display: flex;
  font-display: row;
  justify-content: space-between;
  align-items: center;
  width: 272px;
}
.custom-react-datepicker__label-span {
  font-size: 15px;
  width: 100%;
  color: #2b2b2b;
}
.react-datepicker__input-container input {
  width: 200px;
  height: 19px;
  padding: 5px 10px;
  background: #f5f5f5;
  border: 1px solid white;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 400;
  text-align: center;
  color: #2b2b2b;
}
.react-datepicker-ignore-onclickoutside {
  border: 1px solid #e05185 !important;
  outline: none;
}
.react-datepicker__triangle {
  display: none;
}
.react-datepicker {
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
  border: none;
  border-radius: 5px;
}
.react-datepicker-wrapper {
  width: 102px;
}
.react-datepicker__header {
  height: 50px !important;
  padding: 0 !important;
  background-color: #1f1f23 !important;
  border: none !important;
  position: relative;
  text-align: center;
}
.custom-react-datepicker__select-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 280px;
  height: 50px;
}
.custom-react-datepicker__select-wrapper button {
  background-color: transparent;
  color:white;
  margin: 0 10px;
  border: none;
}
.custom-react-datepicker__select-item {
  display: flex;
  font-display: row;
  justify-content: space-between;
  align-items: center;
  width: 80px;
}
.custom-react-datepicker__select-wrapper select {
  width: 60px;
  height: 30px;
  background-color: #1f1f23;
  color: white;
  border-radius: 3px;
  font-weight: 500;
  font-size: 15px;
}
.custom-react-datepicker__select-wrapper span {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 30px;
  margin-bottom: 5px;
  margin-left: 3px;
  font-weight: 500;
  font-size: 15px;
  color: white;
}
.react-datepicker__month {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 25px !important;
}
.react-datepicker__month-container {
  background-color: #2F2F35;
  border-radius: 5px;
  border: 1px solid white !important;
}
.react-datepicker__week {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 30px;
  margin: 0.5px 0;
}
.react-datepicker__day-name {
  font-size: medium;
  font-weight: 800;
  color: white;
}
.react-datepicker__day {
  width: 20px !important;
  font-size: 15px;
  line-height: 18px !important;
  color: white;
  margin-left: 7px;
  margin-right: 7px;
}
.react-datepicker__day--outside-month {
  color:slategray !important;
}
.react-datepicker__day--selected {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 7px !important;
  line-height: 14px;
}
.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range {
  background-color: #e05185 !important;
  border-radius: 20px !important;
  color: white !important;
}
.react-datepicker__day--keyboard-selected {
  background-color: #E4E4E4 !important;
  color: #2b2b2b !important;
}
.react-datepicker__day--today {
  background-color: #E4E4E4;
  border-radius: 7px;
  color: #2F2F35;
}
.react-datepicker__day--range-start {
  background-color: #e05185 !important;
  border-radius: 7px !important;
  color: white !important;
}
.custom-react-datepicker__split-span {
  display: flex;
  font-display: row;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  width: 11px;
  margin: 0 10px;
  color: #2b2b2b;
}

.react-datepicker {
  z-index: 9999 !important;
}

@media (width >= 768px){
  .custom-react-datepicker__wrapper {
    display: flex;
    font-display: row;
    justify-content: space-between;
    align-items: center;
    width: 680px;
  }
  .custom-react-datepicker__label-span {
    font-size: 37px;
    width: 100%;
    color: #2b2b2b;
  }
  .react-datepicker__input-container input {
    width: 500px;
    height: 47.5px;
    padding: 7.5px 25px;
    background: #f5f5f5;
    border: 1px solid white;
    border-radius: 12px;
    font-size: 37px;
    font-weight: 400;
    text-align: center;
    color: #2b2b2b;
  }
  .react-datepicker-ignore-onclickoutside {
    border: 1px solid #e05185 !important;
    outline: none;
  }
  .react-datepicker__triangle {
    display: none;

  }
  .react-datepicker {
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);
    border: none;
    border-radius: 12px;
  }
  .react-datepicker-wrapper {
    width: 255px;
  }
  .react-datepicker__header {
    height: 125px !important;
    padding: 0 !important;
    background-color: #1f1f23 !important;
    border: none !important;
    position: relative;
    text-align: center;   
  }
  .custom-react-datepicker__select-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 700px;
    height: 125px;
  }
  .custom-react-datepicker__select-wrapper button {
    background-color: transparent;
    color:white;
    margin: 0 25px;
    border: none;
    display: flex;
    font-size: 37px;
  }
  .custom-react-datepicker__select-item {
    display: flex;
    font-display: row;
    justify-content: space-between;
    align-items: center;
    width: 200px;
  }
  .custom-react-datepicker__select-wrapper select {
    width: 150px;
    height: 75px;
    background-color: #1f1f23;
    color: white;
    border-radius: 7.5px;
    font-weight: 500;
    font-size: 37px;
  }
  .custom-react-datepicker__select-wrapper span {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 75px;
    margin-bottom: 12.5px;
    margin-left: 7.5px;
    font-weight: 500;
    font-size: 37px;
    color: white;
  }
  .react-datepicker__month {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 62px !important;
  }
  .react-datepicker__month-container {
    background-color: #2F2F35;
    border-radius: 12px;
    border: 3px solid white !important;
  }
  .react-datepicker__week {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 75px;
    margin: 1.25px 0;
  }
  .react-datepicker__day-name {
    font-weight: 800;
    color: white;
    font-size: 37px;
    line-height: 45px !important;
    margin-top: 10px;
    margin-left: 17px;
    margin-right: 17px;
    width: 50px !important;
  }
  .react-datepicker__day {
    width: 50px !important;
    font-size: 37px;
    line-height: 45px !important;
    color: white;
    margin-left: 17px;
    margin-right: 17px;
  }
  .react-datepicker__day--outside-month {
    color:slategray !important;
  }
  .react-datepicker__day--selected {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 17px !important;
    line-height: 35px;
  }
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range {
    background-color: #e05185 !important;
    border-radius: 50px !important;
    color: white !important;
  }
  .react-datepicker__day--keyboard-selected {
    background-color: #E4E4E4 !important;
    color: #2b2b2b !important;
  }
  .react-datepicker__day--today {
    background-color: #E4E4E4;
    border-radius: 17px;
    color: #2F2F35;
  }
  .react-datepicker__day--range-start {
    background-color: #e05185 !important;
    border-radius: 17px !important;
    color: white !important;
  }
  .custom-react-datepicker__split-span {
    display: flex;
    font-display: row;
    justify-content: center;
    align-items: center;
    font-size: 37px;
    width: 27px;
    margin: 0 25px;
    color: #2b2b2b;
  }
};
`, "",{"version":3,"sources":["webpack://./app/css/datePicker.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,4CAA4C;EAC5C,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;;EAEE,oCAAoC;EACpC,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,eAAe;IACf,WAAW;IACX,cAAc;EAChB;EACA;IACE,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,oCAAoC;IACpC,aAAa;EACf;EACA;IACE,aAAa;;EAEf;EACA;IACE,4CAA4C;IAC5C,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,wBAAwB;IACxB,qBAAqB;IACrB,oCAAoC;IACpC,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,aAAa;EACf;EACA;IACE,6BAA6B;IAC7B,WAAW;IACX,cAAc;IACd,YAAY;IACZ,aAAa;IACb,eAAe;EACjB;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,YAAY;EACd;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,2BAA2B;EAC7B;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,kCAAkC;EACpC;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;EAClB;EACA;IAEE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,eAAe;IACf,4BAA4B;IAC5B,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;EACnB;EACA;;IAEE,oCAAoC;IACpC,8BAA8B;IAC9B,uBAAuB;EACzB;EACA;IACE,oCAAoC;IACpC,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,oCAAoC;IACpC,8BAA8B;IAC9B,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,cAAc;IACd,cAAc;EAChB;AACF","sourcesContent":[".custom-react-datepicker__wrapper {\n  display: flex;\n  font-display: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 272px;\n}\n.custom-react-datepicker__label-span {\n  font-size: 15px;\n  width: 100%;\n  color: #2b2b2b;\n}\n.react-datepicker__input-container input {\n  width: 200px;\n  height: 19px;\n  padding: 5px 10px;\n  background: #f5f5f5;\n  border: 1px solid white;\n  border-radius: 5px;\n  font-size: 15px;\n  font-weight: 400;\n  text-align: center;\n  color: #2b2b2b;\n}\n.react-datepicker-ignore-onclickoutside {\n  border: 1px solid #e05185 !important;\n  outline: none;\n}\n.react-datepicker__triangle {\n  display: none;\n}\n.react-datepicker {\n  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);\n  border: none;\n  border-radius: 5px;\n}\n.react-datepicker-wrapper {\n  width: 102px;\n}\n.react-datepicker__header {\n  height: 50px !important;\n  padding: 0 !important;\n  background-color: #1f1f23 !important;\n  border: none !important;\n  position: relative;\n  text-align: center;\n}\n.custom-react-datepicker__select-wrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 280px;\n  height: 50px;\n}\n.custom-react-datepicker__select-wrapper button {\n  background-color: transparent;\n  color:white;\n  margin: 0 10px;\n  border: none;\n}\n.custom-react-datepicker__select-item {\n  display: flex;\n  font-display: row;\n  justify-content: space-between;\n  align-items: center;\n  width: 80px;\n}\n.custom-react-datepicker__select-wrapper select {\n  width: 60px;\n  height: 30px;\n  background-color: #1f1f23;\n  color: white;\n  border-radius: 3px;\n  font-weight: 500;\n  font-size: 15px;\n}\n.custom-react-datepicker__select-wrapper span {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  height: 30px;\n  margin-bottom: 5px;\n  margin-left: 3px;\n  font-weight: 500;\n  font-size: 15px;\n  color: white;\n}\n.react-datepicker__month {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-top: 25px !important;\n}\n.react-datepicker__month-container {\n  background-color: #2F2F35;\n  border-radius: 5px;\n  border: 1px solid white !important;\n}\n.react-datepicker__week {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  height: 30px;\n  margin: 0.5px 0;\n}\n.react-datepicker__day-name {\n  font-size: medium;\n  font-weight: 800;\n  color: white;\n}\n.react-datepicker__day {\n  width: 20px !important;\n  font-size: 15px;\n  line-height: 18px !important;\n  color: white;\n  margin-left: 7px;\n  margin-right: 7px;\n}\n.react-datepicker__day--outside-month {\n  color:slategray !important;\n}\n.react-datepicker__day--selected {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  border-radius: 7px !important;\n  line-height: 14px;\n}\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range {\n  background-color: #e05185 !important;\n  border-radius: 20px !important;\n  color: white !important;\n}\n.react-datepicker__day--keyboard-selected {\n  background-color: #E4E4E4 !important;\n  color: #2b2b2b !important;\n}\n.react-datepicker__day--today {\n  background-color: #E4E4E4;\n  border-radius: 7px;\n  color: #2F2F35;\n}\n.react-datepicker__day--range-start {\n  background-color: #e05185 !important;\n  border-radius: 7px !important;\n  color: white !important;\n}\n.custom-react-datepicker__split-span {\n  display: flex;\n  font-display: row;\n  justify-content: center;\n  align-items: center;\n  font-size: 15px;\n  width: 11px;\n  margin: 0 10px;\n  color: #2b2b2b;\n}\n\n.react-datepicker {\n  z-index: 9999 !important;\n}\n\n@media (width >= 768px){\n  .custom-react-datepicker__wrapper {\n    display: flex;\n    font-display: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 680px;\n  }\n  .custom-react-datepicker__label-span {\n    font-size: 37px;\n    width: 100%;\n    color: #2b2b2b;\n  }\n  .react-datepicker__input-container input {\n    width: 500px;\n    height: 47.5px;\n    padding: 7.5px 25px;\n    background: #f5f5f5;\n    border: 1px solid white;\n    border-radius: 12px;\n    font-size: 37px;\n    font-weight: 400;\n    text-align: center;\n    color: #2b2b2b;\n  }\n  .react-datepicker-ignore-onclickoutside {\n    border: 1px solid #e05185 !important;\n    outline: none;\n  }\n  .react-datepicker__triangle {\n    display: none;\n\n  }\n  .react-datepicker {\n    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.25);\n    border: none;\n    border-radius: 12px;\n  }\n  .react-datepicker-wrapper {\n    width: 255px;\n  }\n  .react-datepicker__header {\n    height: 125px !important;\n    padding: 0 !important;\n    background-color: #1f1f23 !important;\n    border: none !important;\n    position: relative;\n    text-align: center;   \n  }\n  .custom-react-datepicker__select-wrapper {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 700px;\n    height: 125px;\n  }\n  .custom-react-datepicker__select-wrapper button {\n    background-color: transparent;\n    color:white;\n    margin: 0 25px;\n    border: none;\n    display: flex;\n    font-size: 37px;\n  }\n  .custom-react-datepicker__select-item {\n    display: flex;\n    font-display: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 200px;\n  }\n  .custom-react-datepicker__select-wrapper select {\n    width: 150px;\n    height: 75px;\n    background-color: #1f1f23;\n    color: white;\n    border-radius: 7.5px;\n    font-weight: 500;\n    font-size: 37px;\n  }\n  .custom-react-datepicker__select-wrapper span {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    height: 75px;\n    margin-bottom: 12.5px;\n    margin-left: 7.5px;\n    font-weight: 500;\n    font-size: 37px;\n    color: white;\n  }\n  .react-datepicker__month {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    margin-top: 62px !important;\n  }\n  .react-datepicker__month-container {\n    background-color: #2F2F35;\n    border-radius: 12px;\n    border: 3px solid white !important;\n  }\n  .react-datepicker__week {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    height: 75px;\n    margin: 1.25px 0;\n  }\n  .react-datepicker__day-name {\n    font-size: 37px;\n    font-weight: 800;\n    color: white;\n    font-size: 37px;\n    line-height: 45px !important;\n    margin-top: 10px;\n    margin-left: 17px;\n    margin-right: 17px;\n    width: 50px !important;\n  }\n  .react-datepicker__day {\n    width: 50px !important;\n    font-size: 37px;\n    line-height: 45px !important;\n    color: white;\n    margin-left: 17px;\n    margin-right: 17px;\n  }\n  .react-datepicker__day--outside-month {\n    color:slategray !important;\n  }\n  .react-datepicker__day--selected {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    border-radius: 17px !important;\n    line-height: 35px;\n  }\n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__day--in-range {\n    background-color: #e05185 !important;\n    border-radius: 50px !important;\n    color: white !important;\n  }\n  .react-datepicker__day--keyboard-selected {\n    background-color: #E4E4E4 !important;\n    color: #2b2b2b !important;\n  }\n  .react-datepicker__day--today {\n    background-color: #E4E4E4;\n    border-radius: 17px;\n    color: #2F2F35;\n  }\n  .react-datepicker__day--range-start {\n    background-color: #e05185 !important;\n    border-radius: 17px !important;\n    color: white !important;\n  }\n  .custom-react-datepicker__split-span {\n    display: flex;\n    font-display: row;\n    justify-content: center;\n    align-items: center;\n    font-size: 37px;\n    width: 27px;\n    margin: 0 25px;\n    color: #2b2b2b;\n  }\n};\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
